'use strict';
import * as $i_firebase$002fapp from "firebase/app";
import * as $i_firebase$002fauth from "firebase/auth";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002econfig$0024 from "./presto.config$.js";
var $p;
/** @constructor */
function $c_Lpresto_firebase$helper$() {
  this.bOA = null;
  this.Dn = null;
  $n_Lpresto_firebase$helper$ = this;
  this.bOA = (0, $i_firebase$002fapp.initializeApp)($j_presto$002econfig$0024.$m_Lpresto_config$().rE.Ka, $j_presto$002econfig$0024.$m_Lpresto_config$().rE.Dj);
  this.Dn = (0, $i_firebase$002fauth.getAuth)(this.bOA);
  this.Dn.setPersistence($i_firebase$002fauth.inMemoryPersistence);
}
export { $c_Lpresto_firebase$helper$ as $c_Lpresto_firebase$helper$ };
$p = $c_Lpresto_firebase$helper$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_firebase$helper$;
/** @constructor */
function $h_Lpresto_firebase$helper$() {
}
export { $h_Lpresto_firebase$helper$ as $h_Lpresto_firebase$helper$ };
$h_Lpresto_firebase$helper$.prototype = $p;
var $d_Lpresto_firebase$helper$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_firebase$helper$, "presto.firebase$helper$", ({
  VS: 1
}));
export { $d_Lpresto_firebase$helper$ as $d_Lpresto_firebase$helper$ };
var $n_Lpresto_firebase$helper$;
function $m_Lpresto_firebase$helper$() {
  if ((!$n_Lpresto_firebase$helper$)) {
    $n_Lpresto_firebase$helper$ = new $c_Lpresto_firebase$helper$();
  }
  return $n_Lpresto_firebase$helper$;
}
export { $m_Lpresto_firebase$helper$ as $m_Lpresto_firebase$helper$ };
//# sourceMappingURL=presto.firebase$helper$.js.map
